import React from 'react';
import InfoBoxHeader from '../InfoBoxHeader/InfoBoxHeader';

/**
 * PageContainerLayout - Common layout for all main content areas
 * @param {Object} props
 * @param {string} props.title - Title to display in the header
 * @param {string|React.ReactNode} props.icon - Icon to display in header
 * @param {Array} props.breadcrumbs - Breadcrumb navigation items
 * @param {React.ReactNode} props.children - Page content
 * @param {React.ReactNode} props.rightContent - Optional content for the right side of the header
 */
const PageContainerLayout = ({ 
  showIcon = true,
  title, 
  icon, 
  breadcrumbs,
  children,
  rightContent = null
}) => {
  return (
    <div className="flex flex-col w-full">
      <InfoBoxHeader 
        title={title} 
        showIcon={showIcon}
        icon={icon} 
        breadcrumbs={breadcrumbs}
        rightContent={rightContent}
      />
      <div className="flex-1 px-3 sm:px-6 py-4 sm:py-6">
        {children}
      </div>
    </div>
  );
};

export default PageContainerLayout;